import { render, staticRenderFns } from "./beforestart.vue?vue&type=template&id=1a8e8f4b"
import script from "./beforestart.vue?vue&type=script&lang=js"
export * from "./beforestart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports